import { useMemo } from "react";
import { type SelectProps } from "antd";
import "./party-suggestion.scss";
import { ProjectParticipantInfo } from "../../../../project/api/get-participants";
import { OrganizationSelectOption, OrganizationSelect } from "./index.ts";

// TODO : разобраться в типах
// перенести в project, или что-то ещё
interface OrganizationSuggestionsProps extends SelectProps {
  onPartySelect: (party: ProjectParticipantInfo) => void;
  parties: Array<ProjectParticipantInfo>;
  value?: string;
  defaultValue?: string;
  onClear?: () => void;
}

export function OrganizationSuggestions({
  onPartySelect,
  parties,
  value,
  defaultValue,
  onClear,
  ...rest
}: OrganizationSuggestionsProps) {
  const onChange = (value: string) => {
    const selected = parties.find((el) => el.projectParticipantId === value);
    if (selected) {
      onPartySelect(selected);
    }
  };


  const options = useMemo(
    () =>
      parties.map((val) => {
        return {
          value: val.projectParticipantId,
          label: <OrganizationSelectOption value={val.company} />,
          inputLabel: val.company.shortName,
          className: "party-suggestion",
        };
      }),
    [parties],
  );

  return (
    <OrganizationSelect
      onSelect={onChange}
      onClear={onClear}
      options={options}
      {...rest}
      value={value}
      defaultValue={defaultValue}
    />
  );
}
